import React, { Fragment } from 'react';
import { shape, bool, string } from 'prop-types';
import classnames from 'classnames';
import compose from 'lodash/flowRight';
import {
    withUser,
    withFeatureFlags,
    withCurrency,
    withLocale,
} from 'connectors';
import { Image, Prices } from 'components';
import { currencyShape, localeShape } from 'shapes';
import ProductCardRatings from './ProductCardRatings/ProductCardRatings';
import ProductCardExtra from './ProductCardExtra/ProductCardExtra';
import ProductCardCTA from './ProductCardCTA/ProductCardCTA';

function ProductCardContent({
    product,
    topSale,
    select,
    locale,
    currency,
    hasHideAddtocartCtaEnabled,
    user,
    cdn,
}) {
    const rootClassnames = classnames('product-card__content', {
        'product-card__content--top-sale': topSale,
    });

    const contentTableClassnames = classnames('product-card__informations', {
        'product-card__select': select,
    });

    return (
        <div className={rootClassnames}>
            <div className={contentTableClassnames}>
                {(product.brand_image_fullpath || !topSale) && (
                    <Fragment>
                        <span className="product-card__wrapper">
                            {product.brand_image_fullpath ? (
                                <Image
                                    alt="brand"
                                    className="product-card__wrapper-brand-image"
                                    src={product.brand_image_fullpath}
                                    lazyload
                                    cdn={cdn}
                                />
                            ) : (
                                <span className="product-card__wrapper-brand-image" />
                            )}
                        </span>
                        <div className="product-card-content__name">
                            {product.default_title}
                        </div>
                    </Fragment>
                )}

                <ProductCardRatings
                    ratingCount={product.rating_count}
                    ratingStars={product.rating}
                />
                <ProductCardExtra
                    hasFreeDelivery={product.has_free_delivery}
                    hasMultiPayment={product.has_3x_payment}
                    topSale={null}
                />

                <div className="product-card-prices">
                    <Prices
                        prices={product.prices}
                        locale={locale.value}
                        currency={currency.value}
                        VATExcluded={user && user.isB2B}
                        showFromPrice={product.models_count > 1}
                        showDiscount
                        showRetailPrice
                    />
                </div>
                {!hasHideAddtocartCtaEnabled && (
                    <ProductCardCTA product={product} categoryId="" />
                )}
            </div>
        </div>
    );
}

ProductCardContent.propTypes = {
    product: shape({}).isRequired,
    topSale: bool,
    select: bool,
    locale: localeShape.isRequired,
    currency: currencyShape.isRequired,
    hasHideAddtocartCtaEnabled: bool.isRequired,
    user: shape({
        isB2B: bool,
    }),
    cdn: shape({
        CDN_IMAGE: string,
    }).isRequired,
};

ProductCardContent.defaultProps = {
    topSale: false,
    select: false,
    user: { isB2B: false },
};

export default compose(
    withFeatureFlags({
        hasHideAddtocartCtaEnabled: 'browsing.listing.hide.addtocart.cta',
    }),
    withLocale,
    withCurrency,
    withUser,
)(ProductCardContent);
